// XOAY TỪ KHOÁ (F-1, 06/10/2026 — nhật ký chuỗi 6 giờ). Chạy lặp (chuỗi / lịch) cùng MỘT từ khoá cho ≈ 0 việc sau vòng đầu: cùng kết quả tìm kiếm, mục đạt đã vào sổ, phần còn lại bị AI chấm
// không liên quan (YouTube: 19 video → bỏ đã làm còn 14 → AI giữ 0/14). Nay tham số từ khoá của các khối TÌM nhận NHIỀU từ khoá cách nhau bằng dấu `|` (hoặc xuống dòng); mỗi LẦN CHẠY
// runner dùng MỘT từ khoá theo vòng xoay (bộ đếm theo kịch bản trong bộ nhớ của plugin — src/background/xoay-tu-khoa.ts). Một từ khoá = y như cũ (không đổi bundle/hash, không đổi chữ nào).
// Module THUẦN (không DOM, không I/O): dùng chung runner (chọn từ khoá), Boss/trang sơ đồ (kiểm hợp lệ lúc lưu).
import { normText } from "./vi";

/** Giới hạn Boss kiểm khi tham số có NHIỀU từ khoá (một từ khoá giữ luật cũ: ≤ 500 ký tự cả tham số). */
export const GIOI_HAN_XOAY = { soTu: 10, kyTu: 60 } as const;
/**
 * Tham số được xoay: từ khoá TÌM bài / video / nhóm. KHÔNG gồm tu_khoa_thich ("chỉ thích bài có MỘT TRONG các từ" — đã dùng | / , làm dấu phân cách riêng),
 * tu_khoa_chon_nhom (cách nhau dấu phẩy) hay tu_khoa_tu_tim (chỗ giữ nội bộ, đã gắn vào địa chỉ lúc lắp — xử lý ở xoayUrlTimKiem).
 */
export const THAM_SO_XOAY: ReadonlySet<string> = new Set(["tu_khoa", "tu_khoa_nhom"]);
/**
 * Tham số kịch bản (bundle.params) có được xoay không — kể cả lần dùng thứ n ≥ 2 của khối tìm (lan-dung.ts: tu_khoa_2, tu_khoa_nhom_3…; mỗi lần dùng có ô từ khoá RIÊNG chạy độc lập).
 * Tên của sơ đồ (ts: tu_khoa của nút) vẫn dùng THAM_SO_XOAY.has — nút nào cũng có ts riêng, không hậu tố.
 */
export const laThamSoXoay = (ten: string): boolean => THAM_SO_XOAY.has(ten.replace(/_\d+$/, ""));

const DAU_TACH = /\r\n|[|\r\n]/;
export const dem = (s: string): number => Array.from(s).length;
export const khoaSo = (s: string): string => normText(s).normalize("NFC");

// (06/10/2026, từ khoá nhiều dòng) Từ khoá CÓ ký tự "|" khi lưu được mã hoá "%7C" (và "%" đứng ngay trước 7C / 25 thành "%25") để dấu | TRONG một từ khoá không bị
// hiểu là dấu phân cách. Từ khoá không có "|" thì KHÔNG mã hoá gì (chuỗi lưu y như cũ). Giải mã MỘT lượt: "%257C" → "%7C" (không thành "|").
export const maHoaTuKhoa = (s: string): string => s.replace(/%(?=7C|25)/gi, "%25").replace(/\|/g, "%7C");
export const giaiMaTuKhoa = (s: string): string => s.replace(/%(7C|25)/gi, (_m, c: string) => (c.toUpperCase() === "7C" ? "|" : "%"));

/** Có dấu phân cách (| hoặc xuống dòng) hoặc ký tự đã mã hoá (%7C / %25) không — không có = MỘT từ khoá, giữ nguyên văn như cũ. */
export const coDauPhanCach = (v: unknown): boolean => typeof v === "string" && /[|\r\n]|%(?:7C|25)/i.test(v);

/**
 * Tách danh sách từ khoá. Không có dấu phân cách → đúng một phần tử NGUYÊN VĂN (không cắt khoảng trắng — y như cũ; rỗng → []). Có dấu phân cách → cắt khoảng trắng từng phần,
 * bỏ phần rỗng, bỏ trùng (không phân biệt hoa thường / dấu / khoảng trắng), giữ thứ tự, tối đa GIOI_HAN_XOAY.soTu từ.
 */
export function tachTuKhoa(v: unknown): string[] {
  if (typeof v !== "string") return [];
  if (!coDauPhanCach(v)) return v.trim() ? [v] : [];
  const thay = new Set<string>(), out: string[] = [];
  for (const p of v.split(DAU_TACH)) {
    const t = giaiMaTuKhoa(p.trim());
    if (!t) continue;
    const k = khoaSo(t);
    if (thay.has(k)) continue;
    thay.add(k);
    out.push(t);
    if (out.length >= GIOI_HAN_XOAY.soTu) break;
  }
  return out;
}

export interface TuKhoaChon { giaTri: string; ds: string[]; chi: number }
/** Chọn từ khoá của vòng `vong` (0, 1, 2, … → từ 1, 2, 3, … rồi quay lại). null = không phải danh sách nhiều từ khoá (một từ khoá / rỗng / chỉ dấu |) → KHÔNG đổi gì. */
export function chonTuKhoa(v: unknown, vong: number): TuKhoaChon | null {
  if (!coDauPhanCach(v)) return null;
  const ds = tachTuKhoa(v);
  if (!ds.length) return null;
  const n = Number.isFinite(vong) && vong >= 0 ? Math.floor(vong) : 0;
  const chi = n % ds.length;
  return { giaTri: ds[chi]!, ds, chi };
}

/**
 * Lỗi (tiếng Việt) khi tham số từ khoá có NHIỀU từ khoá mà không hợp lệ; null = hợp lệ hoặc chỉ một từ khoá (luật cũ do nơi gọi kiểm).
 * Phần rỗng giữa các dấu | / chỉ có dấu | → lỗi; quá GIOI_HAN_XOAY.soTu từ; một từ quá GIOI_HAN_XOAY.kyTu ký tự (đếm ký tự thật).
 */
export function loiDanhSachTuKhoa(v: unknown): string | null {
  if (!coDauPhanCach(v)) return null;
  const phan = (v as string).split(DAU_TACH).map((x) => giaiMaTuKhoa(x.trim()));
  if (!phan.some(Boolean)) return "chưa có từ khoá nào (chỉ có dấu | hoặc xuống dòng) — ghi các từ khoá cách nhau bằng dấu |";
  if (phan.some((x) => !x)) return "có từ khoá rỗng giữa các dấu | — bỏ dấu | thừa hoặc điền từ khoá";
  if (phan.length > GIOI_HAN_XOAY.soTu) return `có ${phan.length} từ khoá — tối đa ${GIOI_HAN_XOAY.soTu} từ khoá cách nhau bằng dấu |`;
  const dai = phan.find((x) => dem(x) > GIOI_HAN_XOAY.kyTu);
  if (dai !== undefined) return `từ khoá “${Array.from(dai).slice(0, 20).join("")}…” dài ${dem(dai)} ký tự — mỗi từ khoá tối đa ${GIOI_HAN_XOAY.kyTu} ký tự`;
  return null;
}

// ---- CHẠY THỬ NHIỀU TỪ KHOÁ (F-7, 06/10/2026) ----
// Chạy thử (Nháp) trước đây luôn dùng từ khoá của vòng hiện tại (= đầu danh sách khi chưa chạy thật) → từ khoá đó cho 0 việc thì Boss coi lần chạy thử KHÔNG SẠCH và chặn Chạy thật dù các từ khoá sau tốt.
// Nay Chạy thử thử LẦN LƯỢT từng từ khoá (bắt đầu từ từ khoá chạy thật kế tiếp sẽ dùng) cho tới khi gặp từ khoá có việc; tối đa TOI_DA_TU_KHOA_THU từ khoá, và không bắt đầu lượt mới khi đã quá
// HAN_THU_TU_KHOA_MS kể từ lúc bắt đầu (mỗi lượt = 1 lượt tìm + 1 lượt AI chấm; cả lần chạy thử nên không quá ~3 phút).
export const TOI_DA_TU_KHOA_THU = 4;
export const HAN_THU_TU_KHOA_MS = 120_000;
/** Số lượt Chạy thử: độ dài danh sách từ khoá DÀI NHẤT trong các tham số / địa chỉ xoay (số < 2 hoặc không hợp lệ bỏ qua), tối thiểu 1, tối đa `toiDa`. */
export function soLuotThu(doDaiDs: readonly number[], toiDa: number = TOI_DA_TU_KHOA_THU): number {
  let n = 1;
  for (const d of doDaiDs) if (typeof d === "number" && Number.isFinite(d) && d > n) n = Math.floor(d);
  return Math.max(1, Math.min(toiDa, n));
}

/** Dòng nhật ký kết quả MỘT lượt thử từ khoá: `lyDo` = lý do 0 việc (lyDoNhapKhongViec) hoặc null khi lượt có việc / không có việc cần làm (→ đủ, dừng). */
export function cauKetQuaLuotThu(o: { luot: number; so: number; nhan: string; viTri?: string; lyDo: string | null; soViec: number }): string {
  const dau = `từ khoá ${o.luot}/${o.so} ${o.nhan}${o.viTri ?? ""}`;
  const kq = o.lyDo !== null ? `0 việc — ${o.lyDo}` : `${o.soViec ? `${o.soViec} việc SẼ làm khi chạy thật` : "không có việc cần làm lúc này (không phải lỗi)"} → đủ, không thử thêm từ khoá`;
  return `${dau}: ${kq}`.slice(0, 700);
}

/**
 * Cảnh báo cuối của lần Chạy thử nhiều từ khoá mà MỌI từ khoá đã thử đều 0 việc: nối vào cuối dòng "Nháp: 0 việc SẼ làm khi chạy thật — …" (giữ nguyên tiền tố để Boss nhận ra) danh sách từ khoá đã
 * thử + còn bao nhiêu chưa thử. `daThu` = nhãn các từ khoá đã thử; `tong` = số từ khoá trong danh sách; `toiDa` = số lượt Chạy thử cho phép; hetGio = dừng vì quá HAN_THU_TU_KHOA_MS.
 */
export function ghiChuThuVaoCanhBao(canhBao: string[], o: { daThu: string[]; tong: number; toiDa: number; hetGio: boolean; hanMs?: number }): string[] {
  const i = canhBao.findIndex((c) => c.startsWith("Nháp: 0 việc SẼ làm khi chạy thật — "));
  if (i < 0 || o.daThu.length < 1) return canhBao;
  const con = Math.max(0, o.tong - o.daThu.length);
  const ds = o.daThu.join(" · ");
  const them = o.hetGio ? `dừng thử thêm từ khoá vì đã quá ${Math.round(((o.hanMs ?? HAN_THU_TU_KHOA_MS) / 60_000) * 10) / 10} phút (đã thử ${o.daThu.length}/${o.tong}: ${ds}; còn ${con} từ khoá chưa thử)`
    : con > 0 ? `đã thử ${o.daThu.length} từ khoá, đều 0 việc: ${ds} — mới thử ${o.daThu.length}/${o.tong} từ khoá (Chạy thử thử tối đa ${o.toiDa}; còn ${con} từ khoá chưa thử)`
      : `đã thử ${o.daThu.length} từ khoá, đều 0 việc: ${ds}`;
  const out = [...canhBao];
  out[i] = `${canhBao[i]} · ${them}`;
  return out;
}

/** Mô tả hiện cho người dùng ở ô từ khoá (nhãn / ghi chú tham số). */
export const GHI_CHU_XOAY = "nhiều từ khoá cách nhau bằng dấu |; mỗi lần chạy dùng một từ khoá";

// ---- Địa chỉ tìm kiếm ĐÃ gắn từ khoá lúc lắp (ts_url: Reddit "tìm rồi bình luận", biến thể tự tìm) ----
const KHOA_Q = ["q", "search_query", "query", "keyword", "keywords"];
/**
 * Địa chỉ trang TÌM KIẾM (đường dẫn có "search" hoặc "results") mà từ khoá trong query là danh sách `a | b | c` đã mã hoá → thay bằng từ khoá của vòng (mã hoá lại), giữ nguyên
 * mọi phần khác. null = không phải địa chỉ tìm kiếm / không phải danh sách nhiều từ khoá.
 */
export function xoayUrlTimKiem(url: unknown, vong: number): { url: string; tuKhoa: string; ds: string[]; chi: number } | null {
  if (typeof url !== "string" || url.length > 4000) return null;
  let u: URL;
  try { u = new URL(url); } catch { return null; }
  if (!/^https?:$/.test(u.protocol) || !/search|results/i.test(u.pathname)) return null;
  const re = new RegExp(`([?&])(${KHOA_Q.join("|")})=([^&#]*)`);
  const m = re.exec(url);
  if (!m) return null;
  let giaTri: string;
  try { giaTri = decodeURIComponent(m[3]!.replace(/\+/g, " ")); } catch { return null; }
  const c = chonTuKhoa(giaTri, vong);
  if (!c) return null;
  return { url: url.replace(re, (_t, a: string, b: string) => `${a}${b}=${encodeURIComponent(c.giaTri)}`), tuKhoa: c.giaTri, ds: c.ds, chi: c.chi };
}
